import * as todoActions from 'owa-todo-actions';
import { getTodoActionTelemetryData } from '../selectors/agendaStoreTodoViewSelectors';
import { Todo, ViewType } from 'owa-todo-types';

/**
 * This is a wrapper around `owa-todo-actions` actions to update todos. It allows
 * pass the scenarioId/ viewType in once rather than with every action.
 *
 * @param scenarioId the scenarioId for the agenda
 * @param viewType the todo view type from which the action was taken
 */
export function getTodoScenarioActions(scenarioId: string, viewType: ViewType) {
    if (!scenarioId) {
        throw new Error('The scenarioId should be provided');
    }
    const actionTelemetryData = getTodoActionTelemetryData(scenarioId, viewType);

    return {
        markTodoImportant: (todoId: string) =>
            todoActions.markTodoImportant(todoId, actionTelemetryData),
        removeTodoImportance: (todoId: string) =>
            todoActions.removeTodoImportance(todoId, actionTelemetryData),
        updateTodoSubject: (todoId: string, subject: string) =>
            todoActions.updateTodoSubject(todoId, subject, actionTelemetryData),
        markTodoComplete: (todoId: string) =>
            todoActions.markTodoComplete(todoId, actionTelemetryData),
        markTodoIncomplete: (todoId: string) =>
            todoActions.markTodoIncomplete(todoId, actionTelemetryData),
        createTodos: (todos: Partial<Todo>[], folderId: string) =>
            todoActions.createTodos(todos, folderId, actionTelemetryData),
    };
}
